import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_NON_ATTENDANCE_APPLICATIONS_PROPERTIES } from '@/api/endpoints';
import { NON_ATTENDANCE_APPLICATIONS_PROPERTIES_QUERY_KEY } from '@/api/queryKeys';
import type { NonAttendanceApplicationProperties } from '@/components/AbsenceApplication/types';
import { unwrapAxiosResponse } from '@/utils/axios';

interface Options {
  enabled?: boolean;
}

export const useNonAttendanceProperties = ({ enabled = true }: Options = {}) =>
  useQuery<NonAttendanceApplicationProperties>({
    queryKey: NON_ATTENDANCE_APPLICATIONS_PROPERTIES_QUERY_KEY,
    queryFn: () =>
      apiClient
        .get<NonAttendanceApplicationProperties>(
          API_NON_ATTENDANCE_APPLICATIONS_PROPERTIES,
        )
        .then(unwrapAxiosResponse),
    staleTime: Infinity,
    enabled,
  });
